/**
 * The labels of the readings and configuration keys a bioscope reports over MQTT, by key as
 * the device sends it, lower-cased and without spaces. A key that is not here is shown as
 * sent: the firmware adds keys without a portal release.
 */
export const READING_LABEL_KEYS: Readonly<Record<string, string>> = {
    roll: 'bioscopeDetail.readings.roll',
    pitch: 'bioscopeDetail.readings.pitch',
    depth: 'bioscopeDetail.readings.depth',
    housingtemperature: 'bioscopeDetail.readings.housingTemperature',
    humidity: 'bioscopeDetail.readings.humidity',
    lighttemperature: 'bioscopeDetail.readings.lightTemperature',
    luminosity: 'bioscopeDetail.readings.luminosity',
    watertemperature: 'bioscopeDetail.readings.waterTemperature',
    override: 'bioscopeDetail.readings.override',
    timestamp: 'bioscopeDetail.readings.timestamp',
    bioscopeid: 'bioscopeDetail.readings.bioscopeId',
    timezone: 'bioscopeDetail.readings.timezone',
};

/** The translation key for a reported key, or undefined to show the key as sent. */
export function readingLabelKey(key: string): string | undefined {
    return READING_LABEL_KEYS[key.toLowerCase().replace(/[\s_-]/g, '')];
}
